import styled from "styled-components";
import {Col} from "antd";

export const LabelCol = styled(Col)`
  font-weight: bold;
`;